import { useSelector, shallowEqual } from 'react-redux';

import { useMeterType } from './useMeterType';
import { selectIsDualRate } from 'state/quote/quote-slice';

export const useElecMultirate = () => {
  const { hasE7Meter } = useMeterType();
  const choseDualRateE7 = useSelector(selectIsDualRate, shallowEqual);

  const showE7Tariffs = !!(hasE7Meter && choseDualRateE7);

  return {
    showTOUTariffs: false,
    showE7Tariffs
  };
};
